import { Component, Input } from '@angular/core';

@Component({
    selector: 'my-pie-chart',
    template: require('./pie-chart.component.pug')
})
export class PieChartComponent {
    @Input() pieChartLabels: string[];
    @Input() pieChartData: Array<number>;

    public pieChartType: string = 'pie';

    public pieChartOptions: any = {
        responsive: true,
        legend: {
            display: false,
            position: 'left'
        }
    };

    constructor() { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/shared/ui/pie-chart/pie-chart.component.ts